/**
 * B-26 store product helpers (pure; no React / Firebase so node:test can import them).
 * Chip labels follow the CMS spec: 未建立／已建立／審核中／已核准／被拒／已停售 (+ Play 已啟用／已停用).
 */
export type ChipTone = "neutral" | "info" | "warning" | "success" | "danger";
export interface ProductChip {
  label: string;
  tone: ChipTone;
}

export function iosChip(state: string | null | undefined): ProductChip {
  switch (state) {
    case "created":
      return { label: "已建立（未送審）", tone: "info" };
    case "in_review":
      return { label: "審核中", tone: "warning" };
    case "approved":
      return { label: "已核准", tone: "success" };
    case "rejected":
      return { label: "被拒", tone: "danger" };
    case "removed":
      return { label: "已停售", tone: "neutral" };
    default:
      return { label: "未建立", tone: "neutral" };
  }
}

export function androidChip(state: string | null | undefined): ProductChip {
  switch (state) {
    case "active":
      return { label: "已建立・販售中", tone: "success" };
    case "inactive":
      return { label: "已停售", tone: "neutral" };
    default:
      return { label: "未建立", tone: "neutral" };
  }
}

/** Lines for the confirm dialog: what will be created / updated on both stores. */
export function provisionPlan(input: {
  artistId: string;
  artistName?: string | null;
  priceTier: number;
  previousTier: number | null;
  iosProductId?: string | null;
  androidProductId?: string | null;
  provisioned: boolean;
}): string[] {
  const name = input.artistName || input.artistId;
  const tierLine =
    input.previousTier !== null && input.previousTier !== input.priceTier
      ? `價格：NT$${input.previousTier} → NT$${input.priceTier}／月（只影響新訂閱者；台灣為基準，其他國家自動換算）`
      : `價格：NT$${input.priceTier}／月（台灣為基準，其他國家自動換算）`;
  return [
    `藝人：${name}（${input.artistId}）`,
    tierLine,
    "",
    "App Store Connect：",
    `・訂閱群組「鐵粉・${name}」＋ 訂閱「${name} 鐵粉月卡」（1 個月自動續訂）${input.iosProductId ? `，代號 ${input.iosProductId}` : ""}`,
    "・繁中／英文在地化、全區供應、審核截圖，資料齊全後自動送審（審核約 1–3 天）",
    "Google Play：",
    `・訂閱 ${input.androidProductId ?? "fan_<藝人>_m"}，基本方案 monthly（每月自動續訂），建立後立即可購買`,
    "",
    input.provisioned ? "已建立過：只會補齊缺少的部分並更新名稱／價格，不會重複建立。" : "會在兩個商店建立新商品（之後不能刪除，只能停售）。",
  ];
}
